import api from "./api";

export const listTags = async () => {
  const { data } = await api.get("/tags");
  return data;
};

export const createTag = async (tagData) => {
  const { data } = await api.post("/tags", tagData);
  return data;
};

export const updateTag = async (id, tagData) => {
  const { data } = await api.put(`/tags/${id}`, tagData);
  return data;
};

export const deleteTag = async (id) => {
  const { data } = await api.delete(`/tags/${id}`);
  return data;
};

export const syncContactTags = async (contactId, tagIds) => {
  const { data } = await api.post(`/contacts/${contactId}/tags`, { tagIds });
  return data;
};
